var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBfidTier4BadgeShort = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 73,
  height: 24,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 72,
  height: 24,
  x: 0.5,
  fill: "url(#bfid-tier-4-badge-short_svg__a)",
  rx: 12
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.1 9.263h-2.398V16h-1.48V9.262H8.825V8.047H15.1zM17.736 16H16.25V8.047h1.485zm3.375-6.776v2.206h2.783v1.138h-2.783v2.25h3.531V16h-5.016V8.047h5.016v1.177zm7.356 2.607q.418 0 .726-.104a1.4 1.4 0 0 0 .511-.287 1.2 1.2 0 0 0 .303-.44q.099-.252.099-.555 0-.604-.402-.93-.396-.324-1.215-.324h-.946v2.64zM32.273 16h-1.337q-.38 0-.55-.297l-1.672-2.546a.6.6 0 0 0-.208-.204.7.7 0 0 0-.33-.06h-.633V16h-1.48V8.047h2.426q.808 0 1.386.17.584.165.951.468.375.303.55.726.176.418.176.924 0 .401-.12.759-.116.357-.341.649-.22.292-.55.511a2.7 2.7 0 0 1-.743.347q.142.083.264.198.12.11.22.264zm6.784-2.998v-2.601q0-.369.05-.814l-2.47 3.415zm2.184 0v.787a.28.28 0 0 1-.072.193q-.072.076-.203.077h-.726V16h-1.183v-1.941h-3.355a.38.38 0 0 1-.242-.083.38.38 0 0 1-.132-.215l-.143-.687 3.768-5.033h1.287v4.961zm4.083-5.51h1.056v10.4h-1.056zm10.048 5.582-1.238-3.206a7 7 0 0 1-.23-.738 6 6 0 0 1-.237.743l-1.238 3.201zM57.594 16h-.825a.36.36 0 0 1-.231-.072.44.44 0 0 1-.132-.181l-.737-1.903h-3.537l-.737 1.903a.4.4 0 0 1-.126.176.35.35 0 0 1-.231.077h-.825l3.151-7.882h1.078zm3.473-3.795q.456 0 .803-.121.352-.12.589-.335.24-.22.363-.523.12-.303.12-.666 0-.753-.467-1.177-.462-.423-1.408-.423h-1.265v3.245zm0-4.087q.748.001 1.298.176.555.17.919.49.362.32.539.77.18.45.181 1.006 0 .55-.192 1.007a2.15 2.15 0 0 1-.567.787q-.369.33-.918.517a4 4 0 0 1-1.26.181h-1.265V16h-1.061V8.118z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "bfid-tier-4-badge-short_svg__a",
  x1: 51.89,
  x2: 20.429,
  y1: -19.619,
  y2: 43.124,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.002,
  stopColor: "#F5A833"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.304,
  stopColor: "#FFB444"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.521,
  stopColor: "#FFBE5D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.741,
  stopColor: "#FFBA51"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F7AA35"
})))));
export default SvgBfidTier4BadgeShort;